<template>
  <div class="organization full-height-loading">
    <page-header :title="organization.name ? organization.name : 'Loading...'">
      <div slot="sub-title">
        <i class="el-icon-location"></i>
        {{ organization.address }}, {{ organization.zip }} - {{ organization.city }}, {{ organization.country.name }}
      </div>
      <div slot="controls" v-if="!loading">
        <membership-controls :pending="member.pending" :member="member.member" :invite="member.invite"/>
      </div>
    </page-header>

    <!-- Todo: replace with real stats 
    <el-row :gutter="20" type="flex" justify="center" class="body-padding">
      <el-col :lg="12" :sm="24" class="status-container">
        <stat-card title="Total transactions" stat="+ 21" :transparent="true" />
        <stat-card title="Total litres" stat="+ 2981" :transparent="true" />
        <stat-card title="Preferred gas" stat="Nitrox" :transparent="true"/>
      </el-col>
    </el-row>
    -->

    <el-row :gutter="20" class="body-padding mobile-padding flex-grid">
      <el-col :xs="24" :lg="18" style="order: 2;">
        <div>
          <el-card class="dynamic-margin-bottom">
            <h1 class="title show-mobile">Transactions</h1>
            <transactions :api="userTransactionsApi" />
          </el-card>
        </div>
      </el-col>
      <el-col :xs="24" :lg="6" style="order: 1;">
        <el-card class="no-padding">
          <organization-details :organization="organization" hideEdit/>
        </el-card>
        <el-card class="fty-padding" v-if="stations.length > 0">
          <h1 class="title">Organization stations</h1>
          <station
            v-if="!loading"
            class="my-station-item"
            v-for="station in stations"
            :key="station.id" :station="station"
            :selected="false"
            noStatus
            @highlight="gotoStation(station)" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import OrganizationDetails from './../../organization/OrganizationDetails'
import Transactions from '@/components/dashboard/transactions/Transactions'
import StatCard from '@/components/shared/StatCard'
import StationMap from '@/components/dashboard/stations/map/StationMap'
import MembershipControls from './MembershipControls'
import Station from '@/components/dashboard/stations/Station'

export default {
  name: 'UserOrganization',
  components: {
    StationMap,
    Station,
    Transactions,
    OrganizationDetails,
    StatCard,
    MembershipControls
  },
  data () {
    return {
      loading: true,
      organization: {
        name: '',
        stations: [],
        country: {}
      },
      member: {
        member: false,
        pending: false,
        invite: false
      },
      pending: false,
      map: {
        zoom: 6,
        // eslint-disable-next-line
        center: L.latLng(56.162939, 10.203921),
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }
    }
  },
  computed: {
    stations () {
      return this.organization.stations.map(station => {
        station.organization = { name: this.organization.name }
        return station
      })
    },
    mapCenter () {
      return [this.organization.stations[0].lat, this.organization.stations[0].lng]
    },
    userTransactionsApi () {
      return this.$api.organization(this.$route.params.orgId).user(this.$auth.user.id).transactions
    }
  },
  methods: {
    gotoStation (station) {
      this.$router.push({ name: 'stations', query: { id: station.id } })
    },
    async getOrganization () {
      const response = await this.$http.get(this.$api.organizations.get(this.$route.params.orgId))
      this.organization = response.data

      console.log(this.organization)

      try {
        const OUResponse = await this.$http.get(this.$api.organizations.users.get(this.$route.params.orgId, this.$auth.user.id))
        this.member.pending = OUResponse.data.pending
        this.member.invite = OUResponse.data.invite
        this.member.member = !OUResponse.data.pending && !OUResponse.data.invite
      } catch (error) {
        console.log(error.response)
      }

      this.loading = false
    }
  },
  created () {
    this.getOrganization()
  }
}
</script>

<style lang="scss" scoped>

  .organization {
    margin-bottom: 20px;
  }

  .flex-grid {
    padding-top: 40px;

    @include breakpoint (xs) {
      padding-top: 0px;
      display: flex;
      flex-direction: column;
    }
  }

  .dynamic-margin-bottom {
    margin-bottom: 20px;

    @include breakpoint (xs) {
      margin-bottom: 0px;
    }
  }

  .not-member {
    height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    h3 {
      color: #DCDFE6;
      font-size: 22px;
      text-transform: none;
      margin-top: 5px;
    }

    svg {
      color: #DCDFE6;
      font-size: 22px;
    }
  }

  .edit-button {
    margin: 20px 0px;
    width: 100%;
  }

  .card-margin {
    margin-top: 20px;
    position: relative;
  }

  .card-overflow {
    overflow: visible;
  }

  .search {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    position: absolute;
    right: -12px;
    top: 17px;
    width: 24px;
    height: 24px;
    border-radius: 24px;
    background-color: #008fcc;
    color: white;
    font-size: 12px;
  }

  .controls-group {
    position: absolute;
    right: -12px;
    top: 0px;
    width: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    span {
      margin-top: 12px;
      position:  relative !important;
      right: 0px;
      top: 0px;
    }
  }

  .add-member-from-email {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-end;

    .el-input {
      width: 100% !important;
    }

    button {
      width: 150px;
      margin-top: 20px;
    }
  }

  .status-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 50px 20px 0px 20px;
    flex-wrap: wrap;

    @include breakpoint (xs) {
      display: none;
    }
  }

  .mobile-padding {
    margin-top: 20px;
  }

  .fty-padding {
    margin-top: 20px;
    
    @include breakpoint (xs) {
      padding: 0px;
    }
  }

  .my-station-item {
    margin-left: -20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/user/organization/UserOrganization.vue